import { MaterialTopTabs } from '~/components/TopTabs'

export const unstable_settings = {
  initialRouteName: 'index',
}

export default function FoldersLayout() {
  return (
    <MaterialTopTabs>
      <MaterialTopTabs.Screen
        name="index"
        options={{
          title: 'Folder Chats',
        }}
      />
      <MaterialTopTabs.Screen
        name="replies"
        options={{
          title: 'My Replies',
        }}
      />
    </MaterialTopTabs>
  )
}
